import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useCodes } from '../../store/useCodes'
import { computed, watch } from 'vue'
import { useInventory } from '../../store/useInventory'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'


export default /*#__PURE__*/_defineComponent({
  __name: 'InventoryItemSelection',
  props: {
    task: {},
    taskProperties: {},
    inventoryItemSelection: {}
  },
  emits: ["update:inventoryItemSelection"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

/**only show if:
 * 1) combo task_type and selected rai code
 * 2) if rep has inv
 * 3) if qty_to_rep < 0
 * **/
const showInventoryItems = computed(() => {
  return (
    props.taskProperties &&
    props.taskProperties.rai_code &&
    props.task &&
    props.task.inventory_item_ids &&
    useCodes().isDeductionCode(props.taskProperties.rai_code) &&
    inventoryItemOptions.value.length &&
    useCodes().deductsFromRep(props.taskProperties.rai_code, String(props.task.task_type_id))
  )
})
const inventoryItemSelection = useModelWrapper(props, emit, 'inventoryItemSelection')
//Show items associated to task and in reps BOH
const inventoryItemOptions = computed(() => {
  return useInventory().getInventorySelectionItemsByTaskId(props.task.task_id)
})
//logic to select option
//todo: this may come from task property
const defaultSelectItem = () => {
  if (inventoryItemOptions.value.length) {
    inventoryItemSelection.value = inventoryItemOptions.value[0]
  } else {
    inventoryItemSelection.value = undefined
  }
}
//pick first option on init and update
defaultSelectItem()
watch(
  () => props.task.task_id,
  () => {
    defaultSelectItem()
  }
)

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (showInventoryItems.value)
    ? (_openBlock(), _createBlock(_component_q_select, {
        key: 0,
        filled: "",
        modelValue: _unref(inventoryItemSelection),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inventoryItemSelection) ? (inventoryItemSelection).value = $event : null)),
        options: inventoryItemOptions.value,
        color: "accent",
        label: "Inventory Item Selection",
        behavior: "menu"
      }, null, 8, ["modelValue", "options"]))
    : _createCommentVNode("", true)
}
}

})